import {ZIDXListingSummary} from "./base.js";
import { ZIDX } from "./standaloneLibrary.js";
import {MapMarker} from "./MapMarker.js";
import jQuery from "jquery";
const $ = jQuery.noConflict();

export class ZIDXListingSummaryGroup {
    id: string;
    latitude: number = 0;
    longitude: number = 0;
    listingSummaries: ZIDXListingSummary[];

    constructor(id: string, latitude: number, longitude: number, listingSummaries: ZIDXListingSummary[]) {
        this.id = id;
        this.latitude = latitude;
        this.longitude = longitude;
        this.listingSummaries = listingSummaries;
    }
}
interface ZIDXBounds {
    minLat: number;
    maxLat: number;
    minLng: number;
    maxLng: number;
}

interface ZIDXOriginalCircle {
    lat: number;
    lng: number;
    radiusMiles: number;
}

export class IDXMapBlockKey {
    latitude: number = 0;
    longitude: number = 0;
}

export class IDXMap {
    LISTING_FEET_PER_MAP_LONGITUDE_DEGREE = 288200;
    LISTING_FEET_PER_MAP_LATITUDE_DEGREE = 364000;
    zidx: ZIDX;
    mapIframeLoaded=false;
    mapIframe: HTMLIFrameElement=document.createElement("iframe");
    mapIframePromise:Promise<unknown>|null=null;
    mode="";
    firstMapLoad=true;

    constructor(zidx: ZIDX) {
        this.zidx = zidx;
    }

    loadMapIframe(){
        let self=this;
        if (this.mapIframeLoaded) {
            return;
        }
        this.mapIframeLoaded = true;
        // console.log("loadMapIframe");
        this.mapIframe.id="zidxMapIframe";
        this.mapIframe.width="500";
        this.mapIframe.height="400";
        this.mapIframe.style.border="0px";
        this.mapIframe.style.position="fixed";
        this.mapIframe.style.left="0px";
        this.mapIframe.style.top="100px";
        this.mapIframe.style.zIndex="1";
        this.mapIframe.allowFullscreen=true;
        let polygonString="";
        if(this.zidx.peakidxShadowRoot.getElementById("zidx_search_polygon")) {
            let polygonField = this.zidx.peakidxShadowRoot.getElementById("zidx_search_polygon") as HTMLInputElement;
            polygonString = polygonField.value;//"10830154,28422399,10774562,28369364,10751084,28454062,10736294,28489682,10661383,28502347,10674459,28511846,10748475,28499973"//
        }
        this.mapIframePromise=new Promise((resolve, reject) => {
            // Check if the iframe is already loaded (it might be if it was in the DOM
            // before this function was called).
            if (self.mapIframe.contentWindow && self.mapIframe.contentWindow.document.readyState === 'complete') {
                resolve(self.mapIframe);
            } else {
                // Otherwise, wait for the 'load' event
                self.mapIframe.onload = () => {
                    resolve(self.mapIframe);
                };

                // Optional: Handle errors if the iframe fails to load.
                self.mapIframe.onerror = () => {
                    reject(new Error('Iframe failed to load.'));
                };
            }
        });
        this.mapIframe.src=this.zidx.accountDomain+"/static/map/map.html?origin="+encodeURIComponent(new URL(window.location.href).origin)+"&polygon="+polygonString+"&t="+this.zidx.options.versionDate;
        $(".zidxBodyElement", this.zidx.peakidxShadowRoot).append(this.mapIframe);
        window.addEventListener('message', (event) => {
            // Check the origin to ensure the message is from a trusted source;
            if (event.origin !== self.zidx.accountDomain) {
                return;
            }
            if(event.data.type && event.data.type === "navigate") {
                self.zidx.loadPushStateURL(event.data.link, false);
            }else if(event.data.type && event.data.type === "mapProjectionChanged") {
                if(this.mode=="markers"){
                    let newLatitude = self.getLatitudeInteger(event.data.bounds[1]) + "," + self.getLatitudeInteger(event.data.bounds[3]);
                    let newLongitude = self.getLongitudeInteger(event.data.bounds[0]) + "," + self.getLongitudeInteger(event.data.bounds[2]);
                    if(this.zidx.peakidxShadowRoot.getElementById("zidx_search_polygon")) {
                        let oldLatitude=(this.zidx.peakidxShadowRoot.getElementById("zidx_search_latitude") as HTMLInputElement).value;
                        $("#zidx_search_polygon", this.zidx.peakidxShadowRoot).val(event.data.polygon);
                        $("#zidx_search_latitude", this.zidx.peakidxShadowRoot).val(newLatitude);
                        $("#zidx_search_longitude", this.zidx.peakidxShadowRoot).val(newLongitude);
                        if (this.zidx.zidxBase.lastPostObj.zidx_offset != 0) {
                            $("#zidx_offset", this.zidx.peakidxShadowRoot).val(0);
                        }
                        if(oldLatitude!="" || !this.zidx.zidxMap.firstMapLoad) {
                            if (this.zidx.options.debug) console.log("updateMapBounds check for search form changes");
                            this.zidx.zidxBase.checkForSearchFormChanges(false, true);
                        }else{
                            if (this.zidx.options.debug) console.log("first map load");
                        }
                    }
                }
            }
        });
    }

    hideMap() {
        this.mapIframe.style.display = "none";
    }

    getLatitudeInteger(latitude: number): number {
        // clamp to usa feet
        return Math.max(0, Math.round(latitude * this.LISTING_FEET_PER_MAP_LATITUDE_DEGREE));
    }

    getLongitudeInteger(longitude: number): number {
        // clamp to usa feet
        return Math.max(0, Math.round((180 + longitude) * this.LISTING_FEET_PER_MAP_LONGITUDE_DEGREE));
    }
    getLatitudeFromInteger(latInt: number): number {
        return latInt / this.LISTING_FEET_PER_MAP_LATITUDE_DEGREE;
    }

    getLongitudeFromInteger(lonInt: number): number {
        // Subtract the 180 offset added during encoding
        return (lonInt / this.LISTING_FEET_PER_MAP_LONGITUDE_DEGREE) - 180;
    }

    getRectangleBounds(lat: number, lon: number, radiusMiles: number): ZIDXBounds {
        const MILES_PER_LAT_DEGREE = 69.17;

        // Offset for Latitude
        const latOffset = radiusMiles / MILES_PER_LAT_DEGREE;

        // Offset for Longitude (adjusted for Earth's curvature at this latitude)
        // Convert lat to radians for the cosine function
        const latRadians = lat * (Math.PI / 180);
        const lonOffset = radiusMiles / (MILES_PER_LAT_DEGREE * Math.cos(latRadians));

        return {
            minLat: lat - latOffset,
            maxLat: lat + latOffset,
            minLng: lon - lonOffset,
            maxLng: lon + lonOffset
        };
    }

    getCircleFromBounds(bounds: ZIDXBounds): ZIDXOriginalCircle {
        const MILES_PER_LAT_DEGREE = 69.17;

        // 1. Calculate Center Point (Midpoint of the bounds)
        const lat = (bounds.minLat + bounds.maxLat) / 2;
        const lng = (bounds.minLng + bounds.maxLng) / 2;

        // 2. Calculate Radius
        // Since latOffset = radius / 69.17,
        // then radius = latOffset * 69.17
        // latOffset is half the total height of the bounding box
        const latOffset = (bounds.maxLat - bounds.minLat) / 2;
        const radiusMiles = latOffset * MILES_PER_LAT_DEGREE;

        return {
            lat,
            lng,
            radiusMiles
        };
    }

    renderMapOverlay(listingSummary:ZIDXListingSummary):string{
        let arrHTML:string[]=[];
        let link = this.zidx.getAbsoluteURL(this.zidx.zidxBase.getListingURL(listingSummary));
        arrHTML.push(`
                        <a class="zidxMapMarkerThumbnail" data-id="${listingSummary.id}" href="${link}" target="_top">
                            <div class="zidxMapMarkerThumbnailLink" style="background-size: cover; ${this.zidx.getListingBackgroundImageCSS(listingSummary.photo, true).replace(/&/g, '&amp;').replace(/"/g, '&quot;')} background-position: center;">&nbsp;</div>
                        <div class="zidxMapMarkerThumbnailOverlay">
                        <div class="zidxMapMarkerThumbnailInside">
                        <div class="zidxMapMarkerThumbnailPrice">
            `);
        if (listingSummary.price != 0) {
            arrHTML.push("$" + this.zidx.zidxBase.numberFormat(listingSummary.price));
        }

        arrHTML.push('</div><div class="zidxMapMarkerThumbnailInfo">');

        if (listingSummary.bedrooms != 0) {
            arrHTML.push("<strong>"+listingSummary.bedrooms + "</strong> Beds &nbsp; ");
        }
        if (listingSummary.bathrooms != 0) {
            arrHTML.push("<strong>"+listingSummary.bathrooms + "</strong> Baths &nbsp; ");
        }
        if (listingSummary.halfBaths != 0) {
            arrHTML.push("<strong>"+listingSummary.halfBaths + "</strong> Half Baths &nbsp; ");
        }
        if (listingSummary.sqft != 0) {
            arrHTML.push("<strong>"+listingSummary.sqft + "</strong> SQFT");
        }
        arrHTML.push('</div></div></div></a>');
        return arrHTML.join("");
    }
    getAbbreviatedPrice(price: number): string {
        if (price / 1000 > 1000) {
            // millions
            let temp = price / 1000000;
            let tempString = (Math.round(temp * 100) / 100) + "";
            if (tempString.substr(tempString.length - 1) == "0") {
                tempString = tempString.substr(0, tempString.length - 2);
            }
            return tempString + "M";
        } else {
            // thousands
            let priceRounded=Math.round(price / 1000);
            if(priceRounded<1){
                return "$"+price+"";
            }else{
                return "$"+priceRounded+ "K";
            }
        }
    }
    displayMapMarkers() {
        this.zidx.zidxMap.loadMapIframe();
        let listingSummaryGroups = this.groupListingSummaries(this.zidx.zidxBase.listingData.listings);
        this.zidx.zidxMap.mode="markers";
        let markerMessage: {
            type:string,
            markers: MapMarker[]
        }={
            type:"markers",
            markers:[]
        };
        let count=0;
        for (let key in listingSummaryGroups) {
            count++;
            let listingSummaryGroup = listingSummaryGroups[key];
            let arrLatLng=key.split(",");
            let marker=new MapMarker();
            marker.position.lat=parseFloat(arrLatLng[0]);
            marker.position.lng=parseFloat(arrLatLng[1]);
            let pinLabel="";
            if (listingSummaryGroup.listingSummaries.length == 1) {
                pinLabel = this.getAbbreviatedPrice(listingSummaryGroup.listingSummaries[0].price);
            } else {
                pinLabel = listingSummaryGroup.listingSummaries.length + " Units";
            }
            marker.pinHtml='<div class="zidxMapMarker">'+pinLabel+'</div>';
            if(listingSummaryGroup.listingSummaries.length > 1){
                marker.overlayHtml+=('<div class="zidxMarkerThumbnailContainer">');
            }
            for (let i = 0; i < listingSummaryGroup.listingSummaries.length; i++) {
                let listingSummary= listingSummaryGroup.listingSummaries[i];
                marker.overlayHtml+=this.renderMapOverlay(listingSummary);
            }
            if(listingSummaryGroup.listingSummaries.length > 1){
                marker.overlayHtml+=('</div>');
            }
            markerMessage.markers.push(marker);
            if(markerMessage.markers.length>=200){
                // console.log("markers limited to 200 for performance");
                break;
            }
        }
        if (this.zidx.options.debug) console.log("display map markers", count);
        // console.log("marker message sent | count", markerMessage.markers.length);
        if(this.mapIframe.contentWindow) {
            // console.log("postMessage markers", markerMessage)
            this.mapIframe.contentWindow.postMessage(markerMessage, this.zidx.accountDomain);
        }
    }

    groupLongitudeThreshold = 0.001005;
    groupLatitudeThreshold = 0.001004;

    createMapBlockKey(listing: ZIDXListingSummary): IDXMapBlockKey {
        // we need to move the marker so that nearby grouped listings are on the same exact position as user drags map
        let mapBlockKey = new IDXMapBlockKey();
        mapBlockKey.latitude = Math.round(listing.latitude / this.groupLatitudeThreshold) * this.groupLatitudeThreshold;
        mapBlockKey.longitude = Math.round(listing.longitude / this.groupLongitudeThreshold) * this.groupLongitudeThreshold;
        return mapBlockKey;
    }

    groupListingSummaries(listingSummaries: ZIDXListingSummary[]): { [key: string]: ZIDXListingSummaryGroup } {
        let mapListings: { [key: string]: ZIDXListingSummaryGroup } = {};
        let listingLookup: { [key: string]: ZIDXListingSummary } = {};
        let mapBlockKeys: { [key: string]: IDXMapBlockKey } = {};
        for (let i = 0; i < listingSummaries.length; i++) {
            let listingSummary = listingSummaries[i];
            if (listingSummary.latitude == 0 || listingSummary.longitude == 0) {
                continue;
            }
            listingLookup[listingSummary.id] = listingSummary;
            let mapBlockKey = this.createMapBlockKey(listingSummary);
            let group = new ZIDXListingSummaryGroup(mapBlockKey.latitude + "," + mapBlockKey.longitude, listingSummary.latitude, listingSummary.longitude, [listingSummary]);
            mapListings[mapBlockKey.latitude + "," + mapBlockKey.longitude] = group;
            mapBlockKeys[listingSummary.id] = mapBlockKey;
        }
        for (let firstId in listingLookup) {
            let listingSummary = listingLookup[firstId];
            if (listingSummary.latitude == 0 || listingSummary.longitude == 0) {
                continue;
            }
            if (typeof listingLookup[listingSummary.id] == "undefined") {
                console.log("whoops3");
                continue;
            }
            let mapBlockKey = mapBlockKeys[listingSummary.id];
            let found = false;
            let currentMapListings = mapListings[mapBlockKey.latitude + "," + mapBlockKey.longitude].listingSummaries;
            for (let n = 0; n < currentMapListings.length; n++) {
                if (currentMapListings[n].id == listingSummary.id) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                currentMapListings.push(listingSummary);
            }
            for (let id in listingLookup) {
                let otherListing = listingLookup[id];
                if (otherListing.id == listingSummary.id) {
                    continue; // skip same listing
                }
                if (typeof listingLookup[otherListing.id] == "undefined") {
                    continue; // already grouped
                }
                let otherMapBlockKey = mapBlockKeys[otherListing.id];
                // reduce accuracy of marker when in a group
                if (mapBlockKey.latitude + "," + otherMapBlockKey.longitude == otherMapBlockKey.latitude + "," + otherMapBlockKey.longitude) {
                    // console.log("group", otherListing.id, " to ", listingSummary.id, "latDiff:",latDiff, "longDiff:", longDiff, otherMapBlockKey.latitude, otherMapBlockKey.longitude);
                    let found = false;
                    for (let n = 0; n < currentMapListings.length; n++) {
                        if (currentMapListings[n].id == otherListing.id) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        currentMapListings.push(otherListing);
                    }
                    delete listingLookup[otherListing.id];
                }
            }
        }
        return mapListings;

    }
}
